import * as React from "react";
import type { SVGProps } from "react";
const SvgPackage01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m12 21.6 8.314-4.8V7.2L12 2.4 3.686 7.2v9.6zm0 0v-9m0 0L4.2 7.8m7.8 4.8 7.8-4.8"
    />
  </svg>
);
export default SvgPackage01;
